function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info-pie-chart_svg__clip0_1308_3230)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.269 224.319c-.966 1.986-3.364 2.82-5.317 1.788a119.988 119.988 0 01-58.345-69.854 120 120 0 017.46-90.709c1.003-1.968 3.443-2.668 5.377-1.6l7.704 4.252c1.934 1.068 2.63 3.498 1.637 5.472a103.202 103.202 0 0043.52 137.321c1.947 1.042 2.779 3.429 1.813 5.416l-3.849 7.914z",
  fill: "#2AA4AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.982 212.513c1.332 1.762.988 4.276-.817 5.549a119.995 119.995 0 01-115.68 12.556c-2.037-.856-2.912-3.238-1.989-5.245l3.68-7.994c.924-2.007 3.297-2.877 5.338-2.032a103.202 103.202 0 0098.509-10.692c1.812-1.263 4.317-.922 5.65.84l5.309 7.018z",
  fill: "#1B8388"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120 4c0-2.209 1.792-4.007 4-3.933a119.996 119.996 0 01109.394 80.668 120.005 120.005 0 01-36.084 131.043c-1.69 1.424-4.21 1.119-5.576-.617l-5.442-6.916c-1.366-1.736-1.061-4.245.621-5.677a103.2 103.2 0 00-62.914-181.69C121.792 16.792 120 15.009 120 12.8V4z",
  fill: "#3DC5CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.724 61.685c-1.91-1.11-2.564-3.563-1.39-5.434A120 120 0 01113.092.199c2.205-.127 4.04 1.627 4.093 3.835l.214 8.798c.053 2.208-1.695 4.034-3.899 4.173a103.2 103.2 0 00-80.634 47.697c-1.184 1.865-3.626 2.518-5.535 1.407l-7.607-4.424z",
  fill: "#93DFE3"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "info-pie-chart_svg__clip0_1308_3230"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h240v240H0z"
})));

function SvgInfoPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgInfoPieChart;